import React, { useState, useRef } from 'react';
import { Popper as MuiPopper, ClickAwayListener } from '@mui/material';
import { useAuth } from '@contexts/AuthContext';
import { useScreen } from '@hooks/useScreen';
import { UserAvatar } from '@components/Community/index.js';
import { IconRosetteDiscountCheck, IconRosetteDiscountCheckFilled, IconSelector } from "@tabler/icons-react";
import { Text } from '@fragments';
import UserDropdown from './UserDropdown';

import './styles.scss';

export default function UserSelect() {
    const { user, handleOpenProfileConfigModal } = useAuth();
    const { appearance, setAppearance } = useScreen();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = () => setOpen(prev => !prev);
    const handleClose = () => setOpen(false);

    const handleOpenProfile = () => {
        handleClose();
        handleOpenProfileConfigModal();
    };

    const handleChangeTheme = (mode) => {
        setAppearance(mode);
    };

    const handleLogout = () => {
        handleClose();
        window.logout();
    };

    return (
        <div className="cs-user-select-container mt-1">
            <div
                ref={anchorRef}
                className={`cs-user-select-trigger ${open ? 'active' : ''}`}
                onClick={handleToggle}
            >
                {
                    user?.avatar
                        ? <img className="user-select-avatar-effect" src={user.avatar} alt={user.username} />
                        : null
                }
                <div className="user-info-wrapper">
                    <UserAvatar user={user} size={32} />
                    <div className="user-text">
                        <div className="user-name-row">
                            {user?.verified ? (
                                <IconRosetteDiscountCheckFilled size={14} className="trigger-verified-icon" />
                            ) : null}
                            <Text.span weight={500} contrast={10}>{user?.username}</Text.span>
                        </div>
                        <Text.span contrast={6}>
                            {user?.nickname ? `@${user?.nickname}` : user?.email?.address}
                        </Text.span>
                    </div>
                </div>
                <IconSelector className={`chevron-icon ${open ? 'rotated' : ''}`} />
            </div>

            <MuiPopper
                open={open}
                anchorEl={anchorRef.current}
                placement="top-start"
                style={{ zIndex: 1300 }}
                modifiers={[{ name: 'offset', options: { offset: [0, 6] } }]}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <div>
                        <UserDropdown
                            user={user}
                            appearance={appearance}
                            onChangeTheme={handleChangeTheme}
                            onOpenProfile={handleOpenProfile}
                            onLogout={handleLogout}
                        />
                    </div>
                </ClickAwayListener>
            </MuiPopper>
        </div>
    );
}
